<template>
  <v-container class="mt-4 ml-2" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="elevation-0 transparent">
          <v-card-title class="px-0">
            <span class="text-subtitle-1">Horarios de entrevista</span>
            <v-spacer></v-spacer>
            <v-btn
              class="mr-2"
              small
              tile
              to="/twilio-rh"
            >
              <v-icon left small>mdi-whatsapp</v-icon>
              Inbox
            </v-btn>
            <v-btn
              color="primary"
              dark
              small
              tile
              @click="cargarHorarios"
            >
              <v-icon left small>mdi-refresh</v-icon>
              Actualizar
            </v-btn>
          </v-card-title>

          <v-alert
            v-if="pendienteTabla"
            type="warning"
            dense
            class="mb-4"
          >
            Falta crear la tabla en staging. Mientras tanto el bot sigue ofreciendo lun–vie 9:00 a 17:00.
          </v-alert>

          <v-card class="shadowCard">
            <v-card-title class="pb-0">
              Disponibilidad
              <v-spacer></v-spacer>
              <v-btn
                color="orange"
                dark
                tile
                small
                :disabled="guardandoHora || eliminandoHora || pendienteTabla"
                @click="abrirDialogo"
              >
                <v-icon small left>mdi-calendar-clock</v-icon>
                Agregar horario
              </v-btn>
            </v-card-title>
            <v-card-text class="pt-2 text-caption grey--text">
              Horario de {{ nombreReclutador || 'tu usuario' }} para entrevistas de WhatsApp RH. La cita dura 15 min. Si no cargas nada, el bot usa lun–vie 9:00 a 17:00. No se agenda en domingo.
            </v-card-text>
            <v-card-text class="mt-2">
              <v-row>
                <v-col
                  v-for="dia in dias"
                  :key="dia.valor"
                  cols="12"
                  sm="6"
                  lg="4"
                  xl="3"
                >
                  <v-card class="shadowCard">
                    <v-card-title class="text-subtitle-1 py-3">
                      {{ dia.dia }}
                    </v-card-title>
                    <v-card-text>
                      <div
                        v-if="dia.valor === 7"
                        class="text-caption grey--text py-2"
                      >
                        No se agendan entrevistas en domingo.
                      </div>
                      <v-data-table
                        v-else
                        dense
                        :headers="headers"
                        :items="porDia[dia.valor] || []"
                        item-key="idhorario"
                        class="elevation-0"
                        hide-default-footer
                        :items-per-page="100"
                        :mobile-breakpoint="200"
                      >
                        <template v-slot:item.inicio="{ item }">
                          {{ normalizarHora(item.inicio) }}
                        </template>
                        <template v-slot:item.fin="{ item }">
                          {{ normalizarHora(item.fin) }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-icon
                            small
                            color="primary"
                            :disabled="eliminandoHora"
                            @click="pedirBorrar(item)"
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogHora" max-width="350">
      <v-card>
        <v-card-title class="text-h5">Nuevo horario</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field
                label="Inicio"
                type="time"
                step="1500"
                filled
                dense
                hide-details
                v-model="horaini"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                label="Fin"
                type="time"
                step="1500"
                filled
                dense
                hide-details
                v-model="horafin"
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="pb-0">Selecciona los días:</v-col>
            <v-col
              v-for="dia in diasHabiles"
              :key="'chk-' + dia.valor"
              cols="6"
              class="py-0"
            >
              <v-checkbox
                v-model="diasSeleccionados"
                :label="dia.dia"
                :value="dia.valor"
                hide-details
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            :loading="guardandoHora"
            :disabled="guardandoHora"
            @click="guardar"
          >
            Aceptar
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            :disabled="guardandoHora"
            @click="dialogHora = false"
          >
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDelete" max-width="500">
      <v-card>
        <v-card-title class="text-h5">¿Seguro que deseas eliminar este horario?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text :disabled="eliminandoHora" @click="dialogDelete = false">Cancelar</v-btn>
          <v-btn
            text
            color="primary"
            :loading="eliminandoHora"
            :disabled="eliminandoHora"
            @click="borrar"
          >
            Sí
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Alerta v-if="respuestaAlerta" :parametros="parametros" />
    <carga v-if="cargar" />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import Alerta from '@/components/alertas/Alerta.vue'
import carga from '@/components/alertas/carga.vue'
import validarErrores from '@/mixins/validarErrores'

const DIAS = [
  { dia: 'Lunes', valor: 1 },
  { dia: 'Martes', valor: 2 },
  { dia: 'Miércoles', valor: 3 },
  { dia: 'Jueves', valor: 4 },
  { dia: 'Viernes', valor: 5 },
  { dia: 'Sábado', valor: 6 },
  { dia: 'Domingo', valor: 7 },
]

export default {
  name: 'TwilioRhHorarios',
  mixins: [validarErrores],
  components: { Alerta, carga },
  data: () => ({
    dias: DIAS,
    horarios: [],
    pendienteTabla: false,
    dialogHora: false,
    dialogDelete: false,
    horaini: '',
    horafin: '',
    diasSeleccionados: [],
    guardandoHora: false,
    eliminandoHora: false,
    itemBorrar: null,
    headers: [
      { text: 'Inicio', value: 'inicio' },
      { text: 'Fin', value: 'fin' },
      { text: 'Acciones', value: 'actions', sortable: false, align: 'end' },
    ],
  }),
  computed: {
    ...mapGetters('login', ['getdatosUsuarioERPERP']),
    diasHabiles () {
      return this.dias.filter((d) => d.valor !== 7)
    },
    porDia () {
      const map = { 1: [], 2: [], 3: [], 4: [], 5: [], 6: [], 7: [] }
      for (let i = 0; i < this.horarios.length; i++) {
        const row = this.horarios[i]
        const dia = Number(row.dia)
        if (map[dia]) map[dia].push(row)
      }
      return map
    },
    nombreReclutador () {
      const u = this.getdatosUsuarioERPERP || {}
      if (u.nombre_completo) return u.nombre_completo
      return [u.nombre_usuario, u.apellido_usuario].filter(Boolean).join(' ')
    },
  },
  created () {
    this.cargarHorarios()
  },
  methods: {
    normalizarHora (value) {
      const raw = String(value || '').trim()
      const m = raw.match(/^(\d{1,2}):(\d{2})/)
      if (!m) return raw
      return String(m[1]).padStart(2, '0') + ':' + m[2]
    },
    cargarHorarios () {
      this.cargar = true
      return this.$http.get('twilio-rh.horarios').then((response) => {
        const data = response.data || {}
        this.horarios = data.horarios || []
        this.pendienteTabla = !!data.pendiente_tabla
      }).catch((error) => {
        this.horarios = []
        this.validarError(error)
      }).finally(() => {
        this.cargar = false
      })
    },
    abrirDialogo () {
      this.horaini = ''
      this.horafin = ''
      this.diasSeleccionados = []
      this.dialogHora = true
    },
    guardar () {
      if (this.guardandoHora) return
      if (!this.horaini || !this.horafin) {
        this.validarErrorDirecto('Ingresa hora de inicio y fin.')
        return
      }
      if (this.horaini >= this.horafin) {
        this.validarErrorDirecto('La hora de inicio debe ser menor a la hora de fin.')
        return
      }
      if (!this.diasSeleccionados.length) {
        this.validarErrorDirecto('Selecciona al menos un día (lunes a sábado).')
        return
      }
      this.guardandoHora = true
      return this.$http.post('twilio-rh.horarios.add', {
        dias: this.diasSeleccionados,
        inicio: this.horaini,
        fin: this.horafin,
      }).then((response) => {
        this.dialogHora = false
        this.validarSuccess((response.data && response.data.message) || 'Horario guardado')
        this.cargarHorarios()
      }).catch((error) => {
        this.validarError(error)
      }).finally(() => {
        this.guardandoHora = false
      })
    },
    pedirBorrar (item) {
      this.itemBorrar = item
      this.dialogDelete = true
    },
    borrar () {
      const id = this.itemBorrar && this.itemBorrar.idhorario
      if (!id || this.eliminandoHora) return
      this.eliminandoHora = true
      return this.$http.delete('twilio-rh.horarios.delete/' + id).then(() => {
        this.dialogDelete = false
        this.itemBorrar = null
        this.validarSuccess('Horario eliminado')
        this.cargarHorarios()
      }).catch((error) => {
        this.validarError(error)
      }).finally(() => {
        this.eliminandoHora = false
      })
    },
  },
}
</script>
